import { api } from "./api";

// Crash breadcrumbs: survive a Safari tab crash in localStorage and are sent on the next load.
const KEY = "gh_crumbs";
const ALIVE = "gh_alive";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export function crumb(msg) {
  try {
    const list = read();
    list.push({ t: Date.now(), p: window.location.pathname, m: String(msg).slice(0, 160), n: document.getElementsByTagName("*").length, y: Math.round(window.scrollY) });
    localStorage.setItem(KEY, JSON.stringify(list.slice(-60)));
  } catch { /* storage full or blocked */ }
}

export function startCrumbs() {
  const crashed = localStorage.getItem(ALIVE) === "1";
  const prev = read();
  if (crashed && prev.length) {
    api.post("/client-log", { crumbs: prev, ua: navigator.userAgent }).catch(() => {});
  }
  localStorage.setItem(KEY, "[]");
  localStorage.setItem(ALIVE, "1");
  window.addEventListener("pagehide", () => localStorage.setItem(ALIVE, "0"));
  window.addEventListener("pageshow", () => localStorage.setItem(ALIVE, "1"));
  document.addEventListener("click", (e) => {
    const el = e.target.closest?.("a,button,[role=menuitem]");
    if (el) crumb(`tap ${el.dataset.testid || el.getAttribute("href") || el.textContent.trim().slice(0, 30)}`);
  }, true);
  window.addEventListener("error", (e) => crumb(`error ${e.message}`));
  window.addEventListener("unhandledrejection", (e) => crumb(`reject ${e.reason?.message || e.reason}`));
  crumb(`start ${crashed ? "after-crash" : "clean"}`);
}

// Sample the page a few times after a route change to catch runaway growth.
export function routeCrumbs(path) {
  crumb(`route ${path}`);
  [250, 1000, 3000, 6000].forEach((ms) => setTimeout(() => crumb(`+${ms}ms anim=${document.getAnimations?.().length ?? "?"}`), ms));
}
